import { Configuration, PopupRequest } from '@azure/msal-browser';

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID || '', // Will be loaded from backend
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

// Scopes for authentication
export const loginRequest: PopupRequest = {
  scopes: ['User.Read'],
};

// API configuration
// Use empty string for base URL since we're always on the same origin
// In development: Vite proxy forwards /api requests to localhost:3000
// In production: Both frontend and backend are on same App Service domain
export const API_BASE_URL = import.meta.env.VITE_API_URL || '';
export const ADMIN_API_KEY = import.meta.env.VITE_ADMIN_API_KEY || ''; // Admin tier API key

